<template>
  <router-view></router-view>
</template>

<script>
export default {
  name:  'exhibition-control-partner',
  data() {
    return {
    }
  },
  created() {
    document.title = "中国国际医疗器械博览会 - 合作医院";
  }
}
</script>

<style scoped lang="scss">
</style>
